import { css } from '@mui/material/styles';
export const badgeComponentOverrides = {
    MuiBadge: {
        defaultProps: {
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'right'
            },
            variant: 'standard'
        },
        styleOverrides: {
            badge: ({ theme }) => css `
                border: 1px solid ${theme.tokens.FuelColorWhite};
                background-color: ${theme.tokens.FuelColorGray700};
                color: ${theme.tokens.FuelColorWhite};
            `,
            standard: {
                padding: '0 .25rem'
            },
            dot: {
                borderRadius: '50%',
                height: '10px',
                width: '10px'
            },
            colorWarning: ({ theme }) => css `
                background-color: ${theme.tokens.FuelColorAlertWarningIcon};
                color: ${theme.tokens.FuelColorGray1000};
            `,
            colorSuccess: ({ theme }) => css `
                background-color: ${theme.tokens.FuelColorAlertSuccessIcon};
            `,
            colorInfo: ({ theme }) => css `
                background-color: ${theme.tokens.FuelColorAlertInfoIcon};
            `,
            colorError: ({ theme }) => css `
                background-color: ${theme.tokens.FuelColorAlertErrorIcon};
            `
        }
    }
};
